const isValidSnapshot = (snapshot, organizationId, accountId) => {
  if (!snapshot) return false
  if (snapshot.organizationId !== organizationId) return false
  if (snapshot.accountId !== accountId) return false

  return true
}

export default isValidSnapshot
